<div class="modal-header">
  <h5 class="modal-title">Risolvi Conflitti</h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle mb-0">
      <thead>
      <tr>
        <th>{{stock?.length >0 ? 'Stock':'Produzione'}}</th>
        <th scope="col">{{'Acquisto' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of stock ?? produzione">
        <td>
          <span class="font-14">Anno: {{item?.anno}}</span> <br>
          <span class="font-14">progressivo: {{item?.progressivo}}</span> <br>
          <span class="font-14">codice: {{item?.codice}}</span> <br>
          <span class="font-14">code30: {{item?.code30}}</span> <br>
          <span class="font-14">quantita: {{item?.quantita}}</span> <br>
          <span class="font-14">prodotto: {{item?.prodotto?.replaceAll('_',', ')}}</span> <br>
        </td>
        <td style="width: 800px;">
          <span>
            <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Acquisto'"  [data]="acquisti" [(ngModel)]="item.selezionato" placement="top" style="width: 400px;"></ng-multiselect-dropdown>
          </span>
        </td>
      </tr>
      </tbody>
      <br><br><br><br><br><br><br><br><br>
    </table>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="Save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Salva </span>
  </button>
</div>
